import { Business } from 'app/DTOs/business.enum';
import { ScoreConfig } from 'app/DTOs/score-config.model';
import { Builder } from 'builder-pattern';

export class ScoreConfigFactory {

  constructor() { }

  public static getConfig(
    business: string
  ): ScoreConfig {
    if (!business) return null;

    if (business === Business.SC) return this.getConfigArtemisa();
    if (business === Business.GT) return this.getDefaultConfig();
    if (business === Business.PC) return this.getConfigProperty();

    return null;
  }



  public static getDefaultConfig() {
    return Builder(ScoreConfig)
      .hasVigency(true)
      .pageable(false)
      .eeff(true)
      .generalComments(true)
      .idOperation(true)
      .companyScore(true)
      .analytics(true)
      .companyScore(true)
      .industry(true)
      .typeRisk(false)
      .build();
  }

  public static getConfigArtemisa() {
    return Builder(ScoreConfig)
      .hasVigency(true)
      .pageable(false)
      .eeff(true)
      .generalComments(false)
      .idOperation(true)
      .companyScore(true)
      .analytics(true)
      .companyScore(true)
      .industry(true)
      .typeRisk(false)
      .build();
  }

  public static getConfigProperty() {
    return Builder(ScoreConfig)
      .hasVigency(false)
      .pageable(true)
      .eeff(false)
      .generalComments(true)
      .idOperation(true)
      .companyScore(false)
      .analytics(false)
      .companyScore(false)
      .industry(false)
      .typeRisk(true)
      .build();
  }

  public static isFromArtico(business: string): boolean {
    return business === Business.PC;
  }

  public static isFromAmaru(business: string): boolean {
    return business === Business.GT;
  }

  public static isFromArtemisa(business: string): boolean {
    return business === Business.SC;
  }
}
